<div class="auth-bar">
  <div class="auth-title">
    <img src="assets/img/service.svg" alt="Service" />
    <div>
      <h3>{{ 'login.welcome' | transloco }}</h3>
      <h4>{{ 'login.subtitle' | transloco }}</h4>
    </div>
  </div>
  <div class="login-form">
    <resto-form-with-errors
      restoServerFormError
      [formGroup]="loginForm"
      formId="loginForm"
    >
      <div class="fields">
        <resto-field-with-errors
          icon="email"
          type="email"
          [label]="'login.email.placeholder' | transloco"
          translationKey="login.email.errors"
          formControlName="email"
          [required]="true"
        ></resto-field-with-errors>
        <resto-field-with-errors
          icon="lock_outline"
          type="password"
          [label]="'login.password.placeholder' | transloco"
          formControlName="password"
          translationKey="login.password.errors"
          [required]="true"
        ></resto-field-with-errors>
        <div class="links">
          <a
            href="https://menu.menutech.com/reset-password"
            class="remind-password"
            target="_blank"
            >{{ 'login.remind-password' | transloco }}</a
          >
        </div>
      </div>
      <button
        class="submit-button"
        mat-flat-button
        color="primary"
        type="submit"
        (click)="onSubmit()"
        [disabled]="spinnerState$ | async"
      >
        @if (spinnerState$ | async) {
          <span>
            <mat-spinner
              class="loading-spinner"
              mode="indeterminate"
              [diameter]="24"
            ></mat-spinner>
          </span>
        }
        {{ 'login.login-button' | transloco }}
      </button>
    </resto-form-with-errors>
    <p class="prompt-text body-2">
      {{ 'login.use' | transloco }}
      <a href="https://menu.menutech.com/" target="_blank">{{
        'login.menutech' | transloco
      }}</a>
      {{ 'login.access-credentials' | transloco }}
    </p>
  </div>
</div>
